import { Navigate, Route, Routes } from 'react-router-dom';

import { CongaTestBatchPage } from './CongaTestBatchPage';
import { CongaTestUploadPage } from './CongaTestUploadPage';

/**
 * Sub-router for `/internal/conga-test/*`. The outer route gates this behind
 * `RequirePalmettoFinanceUser`.
 */
export const CongaTestApp = () => (
  <Routes>
    <Route index element={<CongaTestUploadPage />} />
    <Route path=":batchId" element={<CongaTestBatchPage />} />
    <Route path="*" element={<Navigate to="/internal/conga-test" replace />} />
  </Routes>
);
